import { NotificationType, type NurseInShift, type ShiftRequest } from "../../utils/models";

export type BadgeRequestFinder = (shift: Pick<NurseInShift, "id" | "nurseId">) => ShiftRequest | undefined;

/**
 * Finds the replace request behind a shift's Active Request badge. A request belongs to the shift it was
 * raised for, so the badge leaves a shift once its own request closes, even if the nurse has another one.
 * Requests saved without a shift fall back to the nurse.
 */
export const buildBadgeRequestFinder = (requests: readonly ShiftRequest[]): BadgeRequestFinder => {
	const byShift = new Map<string, ShiftRequest>();
	const byNurse = new Map<number, ShiftRequest>();
	for (const request of requests) {
		if ("request_for_shift" in request && request.request_for_shift) {
			// A shift has at most one Active replace-agency request. It wins over any other request on the same
			// shift, since only it has a close time to show, so the badge doesn't depend on the list order.
			if (!byShift.has(request.request_for_shift) || request.request_type === NotificationType.ReplaceAgency) {
				byShift.set(request.request_for_shift, request);
			}
		} else if ("replacement_nurse_id" in request && request.replacement_nurse_id) {
			byNurse.set(request.replacement_nurse_id, request);
		}
	}
	return (shift) => byShift.get(shift.id) ?? byNurse.get(shift.nurseId);
};
